var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main",style:({ overflow: _vm.overflow })},[_c('HeaderItem')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }